// 中文库  zh_cn与 en_us的key值需要保持一致
// 需要双语切换的部分用  $t('字段名')  取值，如 <div>{{ $t('table.home') }}</div>，在script代码中用  this.$t('字段名')  取值
export default {
  bottomLink: {
    address: '地址：中国广东省深圳市宝安区福海街道华丰智谷福海科技产业园B栋B312',
    phone: '电话：0755-23204571',
    email: 'Email：faraday@faradayed.com',
    companyName: '深圳市法拉第电驱动有限公司',
    addressMobile: '地址：中国广东省深圳市宝安区福海街道桥头社区华丰智谷福海科技产业园',
  },
  table: {
    label: '简体中文',
    home: '首页',
    about: '关于法拉第',
    quality: '质量保障',
    product: '产品中心',
    expcenter: '试验中心',
    case: '应用案例',
    download: '资料下载',
    news: '新闻动态',
    service: '服务中心',
    contact: '联系我们',
    companyName: '深圳市法拉第电驱动有限公司',
    visible: '', //有些模块中文页面有而英文页面没有，设置css属性，中文不做处理，英文设置元素不显示。
    visible2: 'display:none',
  },
  home: {
    title: '法拉第-聚焦新能源电机驱动系统研发、生产与销售',
    fldTitle: '深圳法拉第电驱动有限公司',
    introduce: '深圳市法拉第电驱动有限公司，位于“设计之都”“创新之城”美誉滨海城市-深圳市。专注于新能源汽车和工业自动化领域，是一家拥有完全自主知识产权，专业致力于新型能源汽车电机驱动器、专业变频器、通用变频器等电力电子产品的研发、制造、销售和服务的“国家高新技术企业”。',
    fldTitleStyle: 'letter-spacing: 5px;',
    introduceStyle: 'letter-spacing: 5px;text-indent:2em;',
    introduceStyleMobile: 'text-indent:2em',
    moreCase: '更多案例',
    moreCaseStyle: 'letter-spacing:5px',
    textPic: 'text1.png'
  },
  about: {
    tab1: '公司简介',
    tab2: '公司环境',
    tab3: '企业文化',
    tab4: '荣誉资质',
    tab5: '组织架构',
    para1: '深圳市法拉第电驱动有限公司，位于“设计之都”“创新之城”美誉滨海城市-深圳市。专注于新能源汽车和工业自动化领域，是一家拥有完全自主知识产权，专业致力于新型能源汽车电机驱动器、专业变频器、通用变频器等电力电子产品的研发、制造、销售和服务的“国家高新技术企业”。',
    para2: '深圳市法拉第电驱动有限公司坚持“科技创新，人才强企”的理念，拥有技术过硬、综合素质高的人才队伍。',
    para3: '深圳市法拉第电驱动有限公司和产品已通过或取得ISO9001:2008、汽车行业IATF16949质量管理体系认证、电动船驱动器产品船级社CCS认证、国家权威机构EMC认证、国家强制性检验认证、国家级高新技术企业认定、CNAS实验室认可、ISO14001环境管理体系认证等。',
    para4: '服务客户和市面运行产品上百万台，50%以上产品已经达到质保要求，且保持良好运行，得到市场检验、认可、青睐。',
    para5: '深圳市法拉第电驱动有限公司拥有销售一代、开发一代、预研一代的产品经验模式，技术迭代已实现从跟随到引领。',
    para6: '面对即将被引爆的中国新能源汽车消费大时代，公司积极参与新能源汽车电机驱动器的研发、生产和销售，帮助客户提供节能、高效、高质量系统解决方案。',
    para7: '深圳市法拉第电驱动有限公司掌握核心竞争力，积极参与到国家钢铁、石化、化工、有色、建材、纺织、造纸、皮革等行业绿色化改造，增强中国高性能专机变频器供给能力，打破高性能专机变频器长期被国际巨头垄断的情况，同步发展高性能专机变频器和通用变频器产品研发、生产与销售。',
    para8: '深圳市法拉第电驱动有限公司生产制造基地位于中国广东省江门市蓬江区村阮镇井绵二路骑龙山工业园，骑龙山工业园新能源基地占地200亩，投资20 亿元，专业从事于新型能源汽车电机控制器、专业变频器、通用变频器，交流&直流充电桩，随车微充桩、车载循环冷却水泵、加热泵系统的研发、生产与制造。',
    para9: '骑龙山工业园集办公大楼、宿舍楼、高级人才房、会议、展厅酒店、餐厅服务一体，整体风格统一，共8栋大楼。',
    env1: '前台',
    env2: '产品测试',
    env3: '营销中心一角',
    env4: '研发部一角',
    env5: '生产车间一角',
    env6: '生产车间一角',
    env7: '生产车间一角',
    env8: '生产车间一角',
    env9: '产品待老化',
    env10: '产品老化',
    cul1: '法拉第的做事',
    cul2: '和用人原则',
    cul3: '做事原则：今日之事 今日完毕；',
    cul4: '用人原则：人人为才、适用即才、不看学历看努力；',
    cul5: '法拉第的产品理念',
    cul6: '品质是生命、信誉是灵魂、',
    cul7: '创新是动力，责任是前程',
    cul8: '法拉第经营理念',
    cul9: '服务终端、贴近市场、',
    cul10: '保护渠道、实现双赢。',
    cul11: '法拉第的持续精神',
    cul12: '勤:勤劳、勤奋、勤俭，亲临现场，以身作则;',
    cul13: '俭:简俭、节俭、自俭，艰苦朴素节约每一分钱;',
    cul14: '家:国家、大家、小家，壮国家、兴大家、旺小家。',
    cul15: '法拉第的工作精神',
    cul16: '对待困难永不言败的精袖，抓好工作一抓到底的精神；',
    cul17: '对待问题针锋相对的精神，提高效率百折不饶的精神。',
    cul18: '法拉第“三荣一信任”',
    cul19: '一荣: 企业以优秀的合作者为荣；',
    cul20: '二荣: 合作者以发展的企业为荣；',
    cul21: '三荣:厂.商.用户以和谐共赢为荣,',
    cul22: '一信任:厂.商.用户相互信任、对产品信任。',
    cert1: '发明专利证书',
    cert2: '软件著作权',
    cert3: '实用专利证书',
    organization: 'IMG20240506-085844909.jpg',
    mainTextStyle: 'text-indent:2em;',
  },
  product: {
    visible: '',
    visible2: 'display: none',
    tab1: '汽车驱动器',
    tab2: '专业变频器',
    tab3: '通用变频器',
    fed18: 'FED-18系列',
    fed20: 'FED-20系列',
    fed21: 'FED-21系列',
    fed22: 'FED-22系列',
    fed23: 'FED-23系列',
    fd22: 'FD22系列高防护等级液冷专用驱动器',
    fd22s: 'FD22-S系列高防护等级液冷通用驱动器',
    e130: 'E130系统高可靠性通用性矢量变频器',
    titleStyle: '',
    fd22Para1: '输入电压：三相AC380V;三相AC220V;单相AC220V。',
    fd22Para2: '功率范围：55KW~280KW。',
    fd22Para3: '过载能力：150%额定负载60s，180%额定负载3s。',
    fd22Para4: '控制方式：VF、无PG矢量、PG矢量。',
    fd22Para5: '驱动电机：变频器异步电机、永磁同步电机。',
    fd22Spec: 'FD22系列型号规格:',
    fd22sPara1: '输入电压：380VAC/690VAC。',
    fd22sPara2: '功率范围：75KW~630KW。',
    fd22sPara3: '过载能力：150%额定负载60s，180%额定负载3s。',
    fd22sPara4: '控制方式：VF、无PG矢量、PG矢量。',
    fd22sPara5: '驱动电机：变频器异步电机、永磁同步电机。',
    fd22sSpec: 'FD22-S系列型号规格:',
    e130Para1: '输入电压：340VAC-10%~460VAC+10%。',
    e130Para2: '功率范围：0.75KW~160KW。',
    e130Para3: '过载能力：150%额定负载60s，180%额定负载3s。',
    e130Para4: '控制方式：VF、无PG矢量。',
    e130Para5: '驱动电机：变频器异步电机、永磁同步电机。',
    e130Spec: 'E130系列型号规格:',
    e100: '',
    e100Para1: '',
    e100Para2: '',
    e100Para3: '',
    e100Para4: '',
    e100Para5: '',
    e100Spec: '',
    e100b: '',
    e100bPara1: '',
    e100bPara2: '',
    e100bPara3: '',
    e100bPara4: '',
    e100bPara5: '',
    e100bSpec: '',
    e200: '',
    e200Para1: '',
    e200Para2: '',
    e200Para3: '',
    e200Para4: '',
    e200Para5: '',
    e200Spec: ''
  },
  expcenter: {
    para1: '实验中心于2021年4月15开始扩建改造，于5月15日完工。占地面积1390平方米。一楼4个功能室、7个汽车专用高速对拖台架（包含深圳研发中心）、3个高速汽车测功机、二楼17个功能室，电子水泵流量实验室、耐久实验室、环境实验室、电磁兼容实验室、半消声室、三综合振动实验室、耐热耐热实验室、RoHS实验室、盐雾实验室、防水防尘实验室、 充电枪功能性能实验室等。',
    para2: '实验中心于22年11月成功通过中国合格评定国家认可委员会（以下简称：CNAS）的审核，并签发CNAS实验室认可证书。标志着CNAS对FARADAYED测试中心实验室能力的认可，增加客户对实验室的信任以及增强实验室在检测市场中的核心竞争力，CANS覆盖率达85%以上。',
    para3: 'FARADAYED充分学习先进的测试技术、规范和经验，逐步建立起世界一流的专业测评实验室，成为全球范围内开展高压“电控”技术专业化测试与评价的标杆企业之一。',
    title1: '实验室资质',
    title2: '江门实验中心',
    title3: '深圳研发实验中心',
    title4: '实验能力',
    title5: '性能实验',
    title6: '综合耐久实验',
    title7: '环境实验',
    title8: '防护实验',
    title9: '三综合振动实验',
    title10: '盐雾实验',
    title11: '可靠性实验',
    title12: 'EMS实验',
    title13: 'EMI实验',
    title14: '安规实验',
    title15: '流量扬程性能测试系统',
    title16: '气密性，静压，拉力实验',
  },
  case: {
    caseTextStyle: 'font-size: 15px;',
    case1: '磕头机',
    case2: '行车提升机',
    case3: '主轴定位控制',
    case4: '卷染机',
    case5: '主轴定位龙门机床',
    case6: '压铸机',
    case7: '双螺杆挤出机',
    case8: '可口可乐瓶装设备',
    case9: '纺纱机',
    case10: '离心机',
    case11: '直进式拉丝机',
    case12: '吹膜机',
    case13: '塑料拉丝机',
    case14: '焊网机',
    case15: '大理石切割设备',
    case16: '分切机',
    case17: '船舶电动推进驱动系统应用',
    case18: '工业节能改造系统应用',
    case19: 'FD系列工业化应用',
    case20: '商用车电动化应用',
    case21: '商用车电动化应用',
    case22: '商用车电动化应用',
    case23: '商用车电动化应用',
    case24: '船舶电动推进驱动系统应用',
    application1: '分切机张力控制系统方案',
    application2: '自动绕线机应用',
    application3: '复合机张力控制系统方案',
    application4: '冷轧机方案',
  },
  img: {
    banner: {
      banner1: 'banner1.png',
      banner2: 'banner2.png',
      banner3: 'banner3.png',
      banner1b: 'banner1-修改尺寸.png',
      banner2b: 'banner2-修改尺寸.png',
      banner3b: 'banner3-修改尺寸.png',
      bannerProduct1: 'product-banner1.jpg',
      bannerProduct2: 'product-banner2.jpg',
    },
    home: {
      pic1: '资源 12-8.png',
      pic2: '资源 13-8.png',
      pic3: '资源 14-8.png',
    },
    quality: {
      pic1: 'quality-1.png ',
      pic2: 'quality-2.png ',
      pic3: 'quality-3.png ',
      pic4: 'quality-4.png ',
      pic5: 'quality-5.png ',
      pic6: 'quality-6.png ',
      pic7: 'quality-7.png ',
      pic8: 'quality-8.png ',
      pic9: 'quality-9.png ',
      pic10: 'quality-10.png',
      pic11: 'quality-11.png',
      pic12: 'quality-12.png',
      pic13: 'quality-13.png',
      pic14: 'quality-14.png',
    },
    product: {
      fed18: '20240506185058.png',
      fed20: 'FED20-ALL.png',
      fed21: 'FED21-ALL.jpg',
      fed22: 'FED22-ALL.jpg',
      fed23: 'FED21-4.png',
      fd22_1: '图片5.png',
      fd22_2: '20240506171853.png',
      fd22s_1: '图片4.png',
      fd22s_2: '20240506165727.png',
      e130: 'E130-1-en.png',
      e100_1: '',
      e100_2: '',
      e100_3: '',
      e100b_1: '',
      e100b_2: '',
      e100b_3: '',
      e200_1: '',
      e200_2: '',
      e200_3: '',
    },
    expcenter: {
      pic1: 'exp-1.png',
      pic2: 'exp-2.png',
      pic3: 'exp-3.png',
      pic4: 'exp-4.png',
      pic5: 'exp-5.png',
      pic6: 'exp-6.png',
      pic7: 'exp-7.png',
      pic8: 'exp-8.png',
      pic9: 'exp-9.png',
      pic10: 'exp-10.png',
      pic11: 'exp-11.png',
      pic12: 'exp-12.png',
      pic13: 'exp-13.png',
      pic14: 'exp-14.png',
      pic15: 'exp-15.png',
      pic16: 'exp-16.png',
      pic17: 'exp-17.png',
      pic18: 'exp-18.png',
      pic19: 'exp-19.png',
      pic20: 'exp-20.png',
      pic21: 'exp-21.png',
    },
    case: {
      pic1: 'case-24-1.png',
      pic2: 'case-17-1.png',
      pic3: 'case-18-1.png',
      pic4: 'case-19-1.png',
      pic5: 'case-20-1.png',
      pic6: 'case-21-1.png',
      pic7: 'case-22-1.png',
      pic8: 'case-23-1.png',
    }
  },
  download: {
    tab1: '汽车驱动器',
    tab2: '通用变频器',
    tab3: '专业变频器',
    visible: '',
    visible2: 'display:none',
    type1: {
      file1: {
        name: '法拉第电驱动产品手册.pdf',
        type: '文件类型:pdf',
        size: '文件大小：214KB',
        url: 'files/法拉第电驱动产品手册.pdf'
      },
      file2: {
        name: 'FED21五合-集成驱动器规格书-HVSL快插.pdf',
        type: '文件类型:pdf',
        size: '文件大小：1.2MB',
        url: 'files/FED21五合-集成驱动器规格书-HVSL快插.pdf'
      },
      file3: {
        name: 'FED23重卡五合一集成驱动器规格书.pdf',
        type: '文件类型:pdf',
        size: '文件大小：1.4MB',
        url: 'files/FED23重卡五合一集成驱动器规格书.pdf'
      }
    },
    type3: {
      file1: {
        name: 'FD22-S系列逆变器调试手册.pdf',
        type: '文件类型:pdf',
        size: '文件大小：7.3MB',
        url: 'files/FD22-S系列逆变器调试手册.pdf'
      },
      file2: {
        name: 'FD22系列逆变器调试手册.pdf',
        type: '文件类型:pdf',
        size: '文件大小：8.3MB',
        url: 'files/FD22系列逆变器调试手册.pdf'
      },
      file3: {
        name: 'FD22系列逆变器硬件手册.pdf',
        type: '文件类型:pdf',
        size: '文件大小：1.5MB',
        url: 'files/FD22系列逆变器硬件手册.pdf'
      },
      file4: {
        name: '',
        type: '',
        size: '',
        url: ''
      }
    },
    type2: {
      file1: {
        name: '5240010030-V2.1-E130变频器快速调试指南.pdf',
        type: ' 文件类型:pdf',
        size: '文件大小：887KB',
        url: 'files/5240010030-V2.1-E130变频器快速调试指南.pdf'
      }
    }
  },
  contact: {
    visible: '',
    visible2: 'display:none'
  }
}


// WEBPACK FOOTER //
// ./src/lang/zh_cn.js